import React, { useEffect } from 'react';
import { Layout, Grid, Spin, Flex } from 'antd';
import { useAppSelector } from '../../shared/hooks/use-app-selector';
import { useLocalStorageState } from 'ahooks';
import { Header as NewAppHeader } from '../../app/shell/Header';
import { SideMenu } from '../../app/shell/side-menu/SideMenu';

import { useScreenName } from '../../shared/hooks/use-screen-name';
import { isWhitelabelAccount } from '../../shared/utils';
import { FlatSideMenu } from '../../app/shell/flat-side-menu/FlatSideMenu';

const { Content: AntdContent } = Layout;
const { useBreakpoint } = Grid;

export function PageLayout({
  children,
  apiClient,
  trackMethod,
  eventBus,
}: {
  children: JSX.Element;
  apiClient: unknown;
  trackMethod: (
    eventName: string,
    eventPayload?: string | number | object
  ) => void;
  eventBus: unknown;
}) {
  const screens = useBreakpoint();
  const currentMerchant = useAppSelector((state) => state.currentMerchant);

  const isWhitelabel = isWhitelabelAccount(currentMerchant?.whiteLabel);
  const screenName = useScreenName();

  const [sideMenuCollapsed, setSideMenuCollapsed] = useLocalStorageState(
    'sideMenuCollapsed',
    {
      defaultValue: !screens.md || false,
      listenStorageChange: true,
    }
  );

  // Collapse menu when screen is smaller than md
  useEffect(() => {
    if (sideMenuCollapsed === undefined) {
      setSideMenuCollapsed(!screens.md);
    }
  }, [screens.md]);

  const merchantId = currentMerchant?.id || '';
  const merchantSource = currentMerchant?.source || '';

  if (!merchantId) {
    return (
      <Layout>
        <Flex align="center" justify="center" style={{ height: '100vh' }}>
          <Spin></Spin>
        </Flex>
      </Layout>
    );
  }

  return merchantSource && merchantSource === 'onecom_wsb' ? (
    <main id="main-content" className="gv-flex gv-mx-auto gv-w-full gv-h-full">
      <div className="gv-sidebar gv-flex-column-sm gv-h-full gv-max-tab-hidden">
        <FlatSideMenu />
      </div>
      <div className="gv-h-full gv-flex-1 as-PageContent">{children}</div>
    </main>
  ) : (
    <Layout className="as-PageLayout" style={{ minHeight: '100vh' }}>
      <SideMenu screenName={screenName} sideMenuCollapsed={sideMenuCollapsed} />
      <Layout>
        <NewAppHeader
          sideMenuCollapsed={sideMenuCollapsed}
          onSideMenuCollapseChange={setSideMenuCollapsed}
        />
        <AntdContent className="as-PageContent">{children}</AntdContent>
      </Layout>
    </Layout>
  );
}
